import React, { useEffect, useState } from "react";
import { transformResultsToTableData } from "../../../../services/commonService";
import InsightTable from "../InsightTable";
import { useParams } from "react-router-dom";

function HeadlineFinancialMetrics({ headlineFinancialMetrics }) {
  const [tabData, setTabData] = useState([]);
  const { clientName, competitorName } = useParams();
  const allMetrics = [
    { key: "market_cap", label: "Market Cap" },
    { key: "fy2024_revenue", label: "FY2024 Revenue" },
    { key: "growth_rate", label: "Growth Rate" },
    { key: "eps_non_gaap", label: "EPS (non-GAAP)" },
  ];

  // const dummyData = [
  //   {
  //     competitor: clientName ?? "HB Fuller",
  //     market_cap: "$30.5B\u00a0(Jan 2025)",
  //     fy_year: "$226.8B",
  //     growth_rate: "11%",
  //     eps_non_gaap: "$7.10",
  //     market_cap_positive_insight: "Strong cost-efficiency efforts.",
  //     market_cap_negative_insight: "Still lags peers in valuation.",
  //     market_cap_recent_development: "Significant gains in Q3 FY25.",
  //     fy_year_positive_insight: "Improved revenue margins.",
  //     fy_year_negative_insight: "Challenges still persist.",
  //     fy_year_recent_development: "Top-line gains in Q3 FY25.",
  //     growth_rate_positive_insight: "Highest FY25 growth rate.",
  //     growth_rate_negative_insight: "Growth slower than past years.",
  //     growth_rate_recent_development: `Better YoY than ${competitorName ?? 'Tailored Chemical Products'}.`,
  //     eps_non_gaap_positive_insight: "Significant EPS growth.",
  //     eps_non_gaap_negative_insight: "Still lags behind peers.",
  //     eps_non_gaap_recent_development: "Notable improvement in Q3.",
  //   },
  //   {
  //     competitor: competitorName ?? "Tailored Chemical Products",
  //     market_cap: "$251.0B\u00a0(Jan 2025)",
  //     fy_year: "$231.5B",
  //     growth_rate: "10%",
  //     eps_non_gaap: "$9.50",
  //     market_cap_positive_insight: "Digitization focus paid off.",
  //     market_cap_negative_insight: "Faced operational drag.",
  //     market_cap_recent_development: "Vertical expansions announced.",
  //     fy_year_positive_insight: "Consistently strong revenue.",
  //     fy_year_negative_insight: "Q2 performance slightly slowed.",
  //     fy_year_recent_development: "Earnings beat with YoY growth.",
  //     growth_rate_positive_insight: "Digital pivot successful.",
  //     growth_rate_negative_insight: "Hampered by logistics.",
  //     growth_rate_recent_development: "Positive FY26 outlook.",
  //     eps_non_gaap_positive_insight: "EPS boosted by restructuring.",
  //     eps_non_gaap_negative_insight: "Generic margins down.",
  //     eps_non_gaap_recent_development: "Rising EPS trend noted.",
  //   },
  // ];

  useEffect(() => {
    const transformed = transformResultsToTableData(headlineFinancialMetrics);
    setTabData(transformed);
  }, [headlineFinancialMetrics]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Headline Financial Metrics"
      data={tabData}
      metrics={allMetrics}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default HeadlineFinancialMetrics;
